import React, { Component } from 'react'

import { Cards, Chart, CountryPicker } from './components'
import styles from './App.module.css';
import { fetchData } from './api';



class App extends Component {

    // you can still write a constructor if you want

    state = {
        data: {},
        country: '',
    }

    async componentDidMount() {
        const fetchedData = await fetchData();
        this.setState({ data: fetchedData })
    }


    handleCountryChange = async (country) => {
        const fetchedData = await fetchData(country);

        this.setState({ data: fetchedData, country: country });
        console.log(fetchedData);
        //  fetch the data
        // set the state
    }


    render() {
        const {data, country} = this.state

        console.log(data)

        return (
            
            <div className={styles.container}>
                <Cards data={ data }/>
                <CountryPicker handleCountryChange={ this.handleCountryChange }/>
                <Chart data={data} country={country}/>
            </div>
        )
    }
}

export default App;
